module.exports = __webpack_public_path__ + "img/tb-shiping.77a67beb.png";